const normalizeBaseUrl = (value) => {
  if (!value) {
    return 'http://localhost:8000/api/website';
  }

  return value.endsWith('/') ? value.slice(0, -1) : value;
};

export const AGENT_API_BASE_URL = normalizeBaseUrl(
  process.env.REACT_APP_AGENT_API_BASE_URL ||
    process.env.REACT_APP_API_BASE_URL ||
    'http://localhost:8000/api/website'
);

export const AGENT_API_KEY =
  process.env.REACT_APP_WAY2UMRAH_KEY ||
  process.env.REACT_APP_API_KEY ||
  '';

export const AGENT_LOGIN_PATH = '/travel-partner/login';
export const AGENT_REGISTER_PATH = '/travel-partner/register';
export const AGENT_REGISTER_OTP_SEND_PATH = '/travel-partner/register/otp/send';
export const AGENT_REGISTER_OTP_VERIFY_PATH = '/travel-partner/register/otp/verify';
export const AGENT_REGISTER_OTP_RESEND_PATH = '/travel-partner/register/otp/resend';
export const AGENT_VERIFY_EMAIL_PATH = '/travel-partner/verify-email';
export const AGENT_RESEND_VERIFICATION_PATH = '/travel-partner/resend-verification';
export const AGENT_FORGOT_PASSWORD_PATH = '/travel-partner/forgot-password';
export const AGENT_FORGOT_PASSWORD_OTP_VERIFY_PATH = '/travel-partner/forgot-password/otp/verify';
export const AGENT_RESET_PASSWORD_PATH = '/travel-partner/reset-password';
export const AGENT_REFRESH_PATH = '/travel-partner/refresh-token';
export const AGENT_PROFILE_PATH = '/travel-partner/profile';
export const AGENT_ONBOARDING_PATH = '/travel-partner/onboarding';
export const AGENT_ONBOARDING_SUBMIT_PATH = '/travel-partner/onboarding/submit';
export const AGENT_CHANGE_PASSWORD_PATH = '/travel-partner/change-password';
export const AGENT_LOGOUT_PATH = '/travel-partner/logout';
export const AGENT_DASHBOARD_PATH = '/travel-partner/dashboard';
export const AGENT_CUSTOMERS_PATH = '/travel-partner/customers';
export const AGENT_BOOKINGS_PATH = '/travel-partner/bookings';
export const AGENT_COUNTRIES_PATH = '/locations/countries';
export const AGENT_STATES_PATH = '/locations/states';
export const AGENT_CITIES_PATH = '/locations/cities';
